var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tco-rules-container"},[_c('div',{staticClass:"section mt-5"},[_c('CategoryTitle',{attrs:{"category":_vm.category}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }